import { useState, useEffect } from 'react';
import { getAsync } from '../components/public-dashboard/services/api_util';
import { setAnonTokenApi } from '../components/public-dashboard/services/utility';
import { API_ROOT } from '../constants/actionTypes';
import { setAnonToken } from '../middleware/storage';
import { useLocation } from 'react-router-dom';

function useBannerMessages() {
    const [bannerMessagesLoading, setLoading] = useState(true);
    const [bannerMessages, setBannerMessages] = useState([]);
    const [hasMessages, setHasMessages] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setBannerMessages([])
        async function getBannerMessages() {
            setLoading(true);

            let pageName = location.pathname === '/' ? 'home' : location.pathname;

            if (pageName.toLowerCase().includes('user')) {
                pageName = pageName.replace(/\/user/gi, '');
            }

            pageName = pageName.startsWith('/') ? pageName.substring(1) : pageName;
            const isRegistered = location.pathname.toLowerCase().includes('user');
            const messages = await fetchBannerMessages(pageName, isRegistered);
            setHasMessages(messages.length > 0);
            setBannerMessages(messages);
            setLoading(false);
        }
        getBannerMessages();
    }, [location]);

    return { bannerMessagesLoading, bannerMessages, hasMessages };
}

async function fetchBannerMessages(pageName, isRegistered) {
    const response = await getAsync(`${API_ROOT}Banner/GetBannerMessages?pageName=${pageName}&isRegistered=${isRegistered}`);

    if (response.state === 1) {
        return response.data;
    } else {
        return [{ message: "Service Temporarily Unavailable" }];
    }
}

export default useBannerMessages;